import { render } from "./EventDetail.vue?vue&type=template&id=67627f15&scoped=true&ts=true"
import script from "./EventDetail.vue?vue&type=script&lang=ts"
export * from "./EventDetail.vue?vue&type=script&lang=ts"

import "./EventDetail.vue?vue&type=style&index=0&id=67627f15&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67627f15"]])

export default __exports__